import React from "react";
import { Row, FormGroup, Label, Input, Button } from "reactstrap";
import './InputField.css'


const ResponsiveInputFields = (props) => {
    return (
        <Row form>
            <div className='Responsive-Input-Fields'>
                <Row>
                    {props.inputFields.map((modalInput, index) => {
                        return (
                            <FormGroup key={index}>
                                {modalInput.inputType === "select" ? (
                                    <Input
                                        type={modalInput.inputType}
                                        name={modalInput.name}
                                        id={`select-${index}`}
                                        className="select-input"
                                        defaultValue="Choose an option"
                                        onChange={(e) => props.handleRelationDropdown(e.target.value)}
                                    >
                                        <option value="Choose an option" disabled>
                                            Choose an option
                                        </option>
                                        {props.dropDownOptions.map((dropDown) => {
                                            return (
                                                <option key={dropDown.id} value={dropDown.id}>
                                                    {dropDown.assessor_group__assessor_name}
                                                </option>
                                            );
                                        })}
                                    </Input>
                                ) : (
                                    <React.Fragment>
                                        <Input
                                            placeholder="Enter an email Id"
                                            type={modalInput.inputType}
                                            name={modalInput.name}
                                            id={`email-${index}`}
                                            className="email-input"
                                            onChange={(e) =>
                                                props.handleInvitationsEmail(e.target.value)
                                            }
                                        />
                                        <span id={`error-${index}`}></span>
                                    </React.Fragment>
                                )}
                            </FormGroup>
                        );
                    })}
                </Row>
                <div className="form-button-wrapper">
                    <FormGroup check>
                        {props.isDisabled === true ? (
                            <Label check className="disabled-button">
                                <Input
                                    type="checkbox"
                                    checked={props.isChecked}
                                    style={{ cursor: "not-allowed" }}
                                    disabled
                                />
                                ADD ANOTHER
                            </Label>
                        ) : (
                            <Label check>
                                <Input
                                    type="checkbox"
                                    checked={props.isChecked}
                                    onChange={props.handleInputFields}
                                />
                                ADD ANOTHER
                            </Label>
                        )}
                    </FormGroup>
                    {props.isDisabled === true ? (
                        <Button type="submit" className="disabled-button" value="submit">
                            Submit
                        </Button>
                    ) : (
                        <Button onClick={props.handleModalSubmit} className="active-button">
                            Submit
                        </Button>
                    )}
                </div>
            </div>
        </Row>
    );
};


export default ResponsiveInputFields;



// WEBPACK FOOTER //
// ./src/new/Components/Invitations/Sent/Invitation-Modal/Invite-respondants-modal/Responsive/InputField.jsx